import React, {Component} from 'react';
import {HashRouter as Router, Route, Switch} from 'react-router-dom';
import Overlay from '../overlay/overlay';
import Stage from '../stage/stage';
import Hall from '../hall/hall';
import Booth from '../booth/booth';
import BoothPreview from '../booth-preview/booth-preview';

export default class ExpoPreviewer extends Component {
  render() {
    return (
      <div className="expo-previewer">
        <Router>
          <Switch>
            <Route path={"/expos/:expoID/entry"} render={({match})=>(
              <Stage dataURL={`/expos/${match.params.expoID}/entry/stage`} />
            )}/>
            <Route path={"/expos/:expoID/lobby"} render={({match})=>(
              <Stage dataURL={`/expos/${match.params.expoID}/lobby/stage`} />
            )}/>
            <Route path={"/expos/:expoID/halls/:hallID"} render={({match})=>(
              <Hall dataURL={`/expos/${match.params.expoID}/halls/${match.params.hallID}`} />
            )}/>
            <Route path="/expos/:expoID/booths/:boothID" render={({match}) => (
              <div>
                <BoothPreview expoID={match.params.expoID} boothID={match.params.boothID} />
                <Route path="/expos/:expoID/booths/:boothID/contents" render={({match}) => (
                  <Booth dataURL={`/expos/${match.params.expoID}/booths/${match.params.boothID}`} />
                )}/>
              </div>
            )}/>
          </Switch>
        </Router>
        <Overlay />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/expo-previewer/expo-previewer.js